import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

interface EngagementCardProps {
  title: string;
  name: string;
  description: string;
  linkText: string;
  link: string;
}

export const EngagementCard: React.FC<EngagementCardProps> = ({
  title,
  name,
  description,
  linkText,
  link
}) => {
  return (
    <Card className="h-full flex flex-col">
      <CardHeader>
        <CardTitle className="font-normal">{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex-grow">
        <p className="font-semibold text-xl">{name}</p>
        <CardDescription className="text-xs">{description}</CardDescription>
      </CardContent>
      <CardFooter className="">
        <Link to={link} className="flex items-center text-sm font-semibold text-primary underline hover:font-normal">
          {linkText}
          <ArrowRight className="ml-2 h-4 w-4" />
        </Link>
      </CardFooter>
    </Card>
  );
};
